import {
  Tabs,
  Tag,
  Modal,
  Button,
  Form,
  Input,
  Select,
  message,
  Dropdown
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
} from "react";
import {
  CheckOutlined,
  EditOutlined,
  DeleteOutlined,
  HomeOutlined,
  MenuOutlined,
  FolderViewOutlined,
} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import MPAPModal from "./component/MPAPModal";
import commonFn from "@/utils/commonFn";
import { majorProjectAPStatusDictFn } from "@/utils/dict";
import { CustomTable, CustomTableExtend, CustomUpload, CustomModal } from "@/hocComponents";

const MainTable = forwardRef((props, ref) => {
  const [tabsKey, setTabsKey] = useState(1);
  const modalRef = useRef(null);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [filePaths, setFilePaths] = useState([]);
  const [selectedList, setSelectedList] = useState([]);

  const [filedModalFlag, setFiledModalFlag] = useState(false);
  const [detailRecord, setDetailRecord] = useState({});
  const [customModalLoading, setCustomModalLoading] = useState(false);

  const controllersRef = useRef([])

  const createController = () => {
    const controller = new AbortController()
    controllersRef.current.push(controller)
    return controller
  }

  const cancelAllRequests = () => {
    controllersRef.current.forEach(c => c?.abort())
    controllersRef.current = []
  }
  
  const initTableHead = {
    unitName: null,
    projectName: null,
    managerName: null,
    contractor: null,
    glAcct: null,
    requestPay: null,
    otherRequestAmount: null,
    remark: null,
    status: null,
    remainingAmount: null,
    payAmount: null,
    contractedOtherAmount: null,
    amount: null,
    co: null,
  }
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn, pageSize: 100})
  }

  const initColumns = [
    {
      title: "Action",
      key: "action",
      dataIndex: "",
      hidden: [3].includes(tabsKey),
      align: "center",
      width: 60,
      render: (text, record) => (
        (
          (tabsKey === 1 && (commonFn.btnAuthorityFlag('approvedFromGC') || commonFn.btnAuthorityFlag('deleteFromGC'))) || 
          (tabsKey === 2 && (commonFn.btnAuthorityFlag('viewProjectDetail') || commonFn.btnAuthorityFlag('edit') || commonFn.btnAuthorityFlag('delete')))
        ) && (<Dropdown
            menu={{
              items: [
                (tabsKey === 1 && commonFn.btnAuthorityFlag('viewProjectDetailFromGC')) && {
                  key: "viewProjectDetail",
                  icon: <FolderViewOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
                  label: <div>View Project Detail</div>,
                },
                (tabsKey === 1 && commonFn.btnAuthorityFlag('approvedFromGC')) && {
                  key: "approvedFromGC",
                  icon: <CheckOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
                  label: <div>Approval</div>,
                },
                (tabsKey === 2 && commonFn.btnAuthorityFlag('viewProjectDetail')) && {
                  key: "viewProjectDetail",
                  icon: <FolderViewOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
                  label: <div>View Project Detail</div>,
                },
                (tabsKey === 2 && commonFn.btnAuthorityFlag('edit')) && {
                  key: "edit",
                  disabled: !record.isEdit,
                  icon: <EditOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
                  label: <div>Edit</div>,
                },
                ((tabsKey === 1 && commonFn.btnAuthorityFlag('deleteFromGC') && record.isDelete) || (tabsKey === 2 && commonFn.btnAuthorityFlag('delete'))) && {
                  key: "delete",
                  disabled: !record.isDelete,
                  icon: <DeleteOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
                  label: <div>Delete</div>,
                },
              ],
              onClick: (e) => handleMenuClick(e, record),
            }}
            trigger={["click"]}
          >
            <MenuOutlined
              style={{ cursor: "pointer", fontSize: "16px", color: "#0e78a9" }}
            />
          </Dropdown>)
      )
    },
    {
      title: 'Prop - Address, City State',
      dataIndex: "addressCityStateZip",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'unitName')
    },
    {
      title: 'Project Name',
      dataIndex: "projectName",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'projectName'),
    },
    {
      title: 'Project Manager',
      dataIndex: "managerName",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'managerName'),
    },
    {
      title: 'Contractor',
      dataIndex: "contractor",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      hidden: [3].includes(tabsKey),
      onChange: e => tableFilterFn(e, 'contractor'),
    },
    {
      title: "GL-Title",
      dataIndex: "glTitle",
      titleType: "Input",
      width: 120,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'glAcct'),
    },
    {
      title: 'Pay to Contractor',
      dataIndex: "requestPay",
      titleType: '',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'requestPay'),
      render: (text, record) => {
        return (
          <>
            <div>{commonFn.amountToDollarFn(text)}</div>
            {text ? <div>{record.contractor}</div> : null}
          </>
        )
      }
    },
    {
      title: 'Pay to Other Vendor',
      dataIndex: "otherRequestAmount",
      titleType: '',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'otherRequestAmount'),
      render: (text, record) => {
        return (
          <>
            <div>{commonFn.amountToDollarFn(text)}</div>
            {text ? <div>{record.contractor}</div> : null}
          </>
        )
      }
    },
    {
      title: 'Remark',
      dataIndex: "remark",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'remark'),
    },
    {
      title: 'Request Date',
      dataIndex: "createTime",
      titleType: 'DatePicker',
      isSorter: false,
      hidden: [3].includes(tabsKey),
      format: 'MM/DD/YYYY',
      onChange: (e) => tableFilterFn(e, 'createTimeStr', 'DatePickerFormat'),
    },
    {
      title: 'Approval Status',
      dataIndex: "status",
      titleType: 'Select',
      isSorter: true,
      sortterMultiple: 3,
      hidden: [2].includes(tabsKey),
      selectOptions: majorProjectAPStatusDictFn({tabsKey}).statusMatchList,
      onChange: e => tableFilterFn(e, 'status', 'Select'),
      render: (text, record) => {
        const { statusMatchObj } = majorProjectAPStatusDictFn({text, record})
        const {approver, isColor, printBy, checkDate, colorStr} = record
        return (
            <Tag 
              color={statusMatchObj.color}
              onClick={(e) => handleMenuClick({key: tabsKey === 3 ? 'onlyNew' : 'view'}, record)}
              style={{
                cursor: 'pointer',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                textAlign: 'center'
            }}
            >
              <div>{statusMatchObj.label}</div>
              {(tabsKey === 2 && approver) && <div>{approver}</div>}
              {tabsKey === 3 ? (
                <>
                  {<div style={{ color: colorStr === '#dd4b39' ? 'rgba(0,0,0,0.88)' : undefined}}>
                    {isColor ? printBy : approver}
                  </div>}
                  {isColor && <div>{checkDate}</div>}
                </>
              ) : null}
            </Tag>
          )           
        },
    },
    {
      title: 'Remaining',
      dataIndex: "remainingAmount",
      titleType: '',
      isSorter: true,
      hidden: [3].includes(tabsKey),
      sortterMultiple: 3,
      isAmountFlag: true,
      onChange: e => tableFilterFn(e, 'remainingAmount'),
    },
    {
      title: "Total Paid",
      dataIndex: "payAmount",
      titleType: "",
      hidden: [3].includes(tabsKey),
      isAmountFlag: true,
      onChange: (e) => tableFilterFn(e, 'payAmount'),
    },
    {
      title: 'Total Other Paid',
      dataIndex: "contractedOtherAmount",
      titleType: '',
      isSorter: true,
      hidden: [3].includes(tabsKey),
      sortterMultiple: 3,
      isAmountFlag: true,
      onChange: e => tableFilterFn(e, 'contractedOtherAmount'),
    },
    {
      title: 'Orginal Contracted',
      dataIndex: "amount",
      titleType: '',
      isSorter: true,
      hidden: [3].includes(tabsKey),
      sortterMultiple: 3,
      isAmountFlag: true,
      onChange: e => tableFilterFn(e, 'amount'),
    },
    {
      title: 'Change Order',
      dataIndex: "co",
      titleType: '',
      isSorter: true,
      hidden: [3].includes(tabsKey),
      sortterMultiple: 3,
      isAmountFlag: true,
      onChange: e => tableFilterFn(e, 'co'),
    },
    {
      title: 'Approval Status',
      dataIndex: "status",
      titleType: 'Select',
      isSorter: true,
      sortterMultiple: 3,
      hidden: [1, 3].includes(tabsKey),
      selectOptions: majorProjectAPStatusDictFn({tabsKey}).statusMatchList,
      onChange: e => tableFilterFn(e, 'status', 'Select'),
      render: (text, record) => {
        const { statusMatchObj } = majorProjectAPStatusDictFn({text, record})
        const {approver, isColor, printBy, checkDate, colorStr} = record
        return (
            <Tag 
              color={statusMatchObj.color}
              onClick={(e) => handleMenuClick({key: 'view'}, record)}
              style={{
                cursor: 'pointer',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                textAlign: 'center'
            }}
            >
              <div>{statusMatchObj.label}</div>
              {(tabsKey === 2 && approver) && <div>{approver}</div>}
              {tabsKey === 3 ? (
                <>
                  {<div style={{ color: colorStr === '#dd4b39' ? 'rgba(0,0,0,0.88)' : undefined}}>
                    {isColor ? printBy : approver}
                  </div>}
                  {isColor && <div>{checkDate}</div>}
                </>
              ) : null}
            </Tag>
          )           
        },
    },
  ]

  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 100,
    total: 0,
  });

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    const controller = createController()
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      type: tabsKey,
      ...tableHead,
    };
    const response = await http.post(api.contractGetRecordSummary, {...params}, {signal: controller.signal});
    if(!response) return
    if (response && response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const initColunmsFn = () => {
    setPagination({
      current: 1,
      pageSize: 100,
      total: 0,
    })
    setTableList([])
    setSelectedList([])
    setTableHead(initTableHead);
    setColumns(initColumns);
    cancelAllRequests()
  }

  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 100)
  }, [refreshKey])

  const customModalRef = useRef(null);
  const [customModalConfig, setCustomModalConfig] = useState({
    width: 500,
  });

  const [MPAPMConfig, setMPAPMConfig] = useState({});

  const openModalFn = (params, data) => {
    setMPAPMConfig({
      ...data,
      submitInitFn: MPAPModalSubmitFn
    })
    modalRef.current.openModal({
      ...params,
      statusId: data.id,
      // colorStr,
    })
  }

  const handleMenuClick = async (item, record) => {
    const { key } = item
    if (["send"].includes(key)) {
      if(!selectedList.length) return message.warning("Please select at least one item") ;
        secondConfirmBeforeFn({typeMatchKey: 100})
      return;
    } else if(["approvedFromGC"].includes(key)){
        openModalFn({
          type: 'send',
          modalName: 'Approval',
        }, record)
    } else if(['edit'].includes(key)){
      openModalFn(
        {
          type: 'edit',
          modalName: 'Edit',
        },
        {
          ...record,
          editUrl: tabsKey === 2 ? api.contractUpdateApprovalRecord : undefined
        }
      )
    } else if(['delete'].includes(key)){
      secondConfirmBeforeFn(record)
    } else if(['view'].includes(key)){
        openModalFn({
          type: 'view',
          modalName: 'View',
        }, record)
    } else if(['onlyNew'].includes(key)){
        openModalFn({
          type: 'onlyNew',
          modalName: 'Edit',
        }, record)
    } else if(['viewProjectDetail'].includes(key)){
      const route = `/JobRequests/MajorProjectEdit?id=${record.contractId}&projectName=${record.vendorName}`
      const url = `${window.location.origin}#${route}`;
      window.open(url, "_blank", "noopener,noreferrer");
    }
  }

  const secondConfirmBeforeFn = (record) => {
    const statusMatch = {
      1: 5,
      2: 3,
      4: 6,
      // 5: 6,
      9: 103,
      10: 102,
      201: 104,
      202: 104
    }
    const typeMatch = {
      1: {
        deleteContent: 'From GC',
        url: api.updateRecordStatus,
        params: {
          id: record.id,
          status: statusMatch[record.status],
        },
        fnType: 'post',
        fn: MPAPModalSubmitFn
      },
      2: {
        deleteContent: 'P.M Approved Request',
        url: api.contractDelApprovalRecord,
        params: {
          id: record.id,
        },
        fnType: 'get',
        fn: MPAPModalSubmitFn
      },
      // send
      100: {
        content: `Are you sure to send for check approval ${selectedList.length} check(s).`,
        url: api.contractApprovalBatchRecord,
        params: {
          recordIds: selectedList.map(item => item.id),
        },
        messageName: 'Send',
        fnType: 'post',
        fn: MPAPModalSubmitFn
      }
    }
    const item = typeMatch[record?.typeMatchKey || tabsKey]
    setCustomModalConfig({
      ...customModalConfig,
      ...item,
      onOkFn: () => deleteFn(item)
    })
    customModalRef.current.openModalFn()
  }

  const deleteFn = async(item) => {
    setCustomModalLoading(true)
    const {url, params, fnType, fn, messageName} = item
    const obj = fnType === 'get' ? {params} : {...params}
    const response = await http[fnType](url, obj);
    if (response.code === "1") {
      message.success(`${messageName ?? 'Deleted'} successfully`);
      MPAPModalSubmitFn()
    } else {
      setTimeout(() => {
        commonFn.modalFailedFn(response)
      }, 500);
    }
    setCustomModalLoading(false)
  }

  const MPAPModalSubmitFn = () => {
    setSelectedList([])
    setTableHead(pre => {
      getTableListFn(pagination.current, pagination.pageSize, pre)
      return pre
    })
  }


  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('Download') && 'download']}
      >
        <Tabs 
          defaultActiveKey={tabsKey} 
          items={[
            {key: 1, label: "From GC"},
            {key: 2, label: "Ready for Check Approval"},
            {key: 3, label: "Request History"},
          ]}
          onChange={key => (setTabsKey(key), setRefreshKey(+new Date()))}
        />
      </CustomTableExtend>

      {
        tabsKey === 2 && [{
          name: 'Send For Check Approval',
          key: 'send',
          icon: <CheckOutlined />,
          className: 'btnGreen'
        }]?.map(item => (
          <commonFn.BtnAuthorityFn authKey={item.key}>
            <Button style={{marginBottom: 20, marginRight: 20, display: 'inline'}} onClick={() => handleMenuClick(item)} loading={customModalLoading}>
              {item?.icon}
              {item?.name}
            </Button>
          </commonFn.BtnAuthorityFn>
        )) || null
      }
      {
        tabsKey === 2 && [
          {
            totalName: 'Selected total (',
            totalList: [1, 2],
            amountName: ') Grand Total: ',
            amountKey: 'recordAmount',
            authKey: 'GrandTotal',
          },
          {
            totalName: 'Major Project Total (',
            totalList: [1],
            amountName: ') Major Total: ',
            amountKey: 'requestPay',
            authKey: 'MajorTotal',
          },
          {
            totalName: 'Other Total (',
            totalList: [2],
            amountName: ') Other Total: ',
            amountKey: 'otherRequestAmount',
            authKey: 'OtherTotal',
          }
        ]?.map(item => (
          // <commonFn.BtnAuthorityFn authKey={item.authKey}>
            <Button className="btnGreen" style={{ cursor: "text" }}>
              { item.totalName + 
                selectedList?.filter(v => item.totalList.includes(v.recordType))?.length + 
                item.amountName + 
                commonFn.amountToDollarFn(selectedList?.map((v) => v[item.amountKey]).reduce((acc, curr) => acc + curr, 0))
              }
            </Button>
          // </commonFn.BtnAuthorityFn>
        )) || null
      }
      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowSelection={[2].includes(tabsKey) && {
          preserveSelectedRowKeys: true,
          type: tabsKey === 1 ? "radio" : "checkbox ",
          selectedRowKeys: selectedList.map(item => item.id),
          onChange: (selectedRowKeys, selectedRows) => {
            setSelectedList(selectedRows);
          },
        } || false}
        rowKey="id"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="360px"
      />

      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <HomeOutlined style={{ marginRight: "8px" }} />
            File
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        open={filedModalFlag}
        onCancel={() => setFiledModalFlag(false)}
        footer={null}
        maskClosable={false}
        // destroyOnClose={true}
        width="80%"
      >
      <div
        key={detailRecord?.id}
        style={{ height: "100%", display: "flex", flexDirection: "column" }}
      >
        <CustomUpload
          setFilePaths={setFilePaths} 
          filePaths={filePaths} 
          setBtnDisabled={setBtnDisabled}
          btnDisabled={btnDisabled}
          isEdit={true}
          vendorPaymentId={detailRecord?.id || undefined}
          foreignId={detailRecord?.id || undefined}
          preCalFile={detailRecord?.preCalFile || undefined}
          type={detailRecord?.type || undefined}
          customConfig={{
            pdfHeight: '62vh',
            noShowUpload: true,
            noSubmitBtn: true,
            pageName: 'CheckApproval'
          }}
        />
        <div style={{textAlign: 'center', marginTop: 20}}>
          <Button onClick={() => setFiledModalFlag(false)}>
            cancel
          </Button>
        </div>
      </div>
      </Modal>

      <CustomModal
        ref={customModalRef}
        customConfig={customModalConfig} 
      />
      
      <MPAPModal
        ref={modalRef}
        MPAPMConfig={MPAPMConfig}
      />
    </div>
  );
});
export default MainTable;
